import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

import { HttpService } from '../service/http.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-transactions-vat-report',
  templateUrl: './transactions-vat-report.component.html',
  styleUrls: ['./transactions-vat-report.component.css']
})
export class TransactionsVatReportComponent implements OnInit {

  monthOptions: SelectItem[] = [];
  yearOptions: SelectItem[] = [];
  selectedYear!: number;
  //range: 1-12
  selectedMonth!: number;
  selectedOption!: number;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    let today = moment();
    let thisYear = today.year();
    for(let i = 0; i <10; i++){
      this.yearOptions.push({label: (thisYear - i).toString(), value: thisYear - i});
    }
    this.selectedYear = thisYear;
    this.setMonthsOfThisYear();
    this.selectedMonth = today.month() + 1;
    this.selectedOption = 1;
  }

  refreshMonthOptions(){
    this.monthOptions = [];
    let thisYear = moment().year();
    if(this.selectedYear == thisYear){
      this.setMonthsOfThisYear();
    } else {
      for(let i = 12; i > 0; i--){
        this.monthOptions.push({label: i.toString(), value: i});
      }
    }
  }

  setMonthsOfThisYear(){
    let thisMonth = moment().month() + 1;
    for(let i = 0; i < 12; i++){
      if(thisMonth - i > 0){
        this.monthOptions.push({label: (thisMonth - i).toString(), value: thisMonth - i});
      }
    }
  }

  exportFile(){
    if(this.selectedOption == 2){
      this.exportCsv();
    } else if(this.selectedOption == 1){
      this.exportXlsx();
    }
  }

  exportXlsx(){
    let thisYear = moment().year();
    let zeroBasedMonth = this.selectedMonth - 1;
    let monthName = moment([thisYear, zeroBasedMonth, 1]).format("MMMM");
    this.httpService.getMonthlyVatXlsx(this.selectedMonth, this.selectedYear, this.selectedOption).subscribe(res => {
      let binaryData = [];
      binaryData.push(res);
      this.downloadFile(binaryData, "TVA_" + monthName + "_" + this.selectedYear + ".xlsx");
    });
  }

  downloadFile(bytes: BlobPart[], fileName: string) {
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(bytes, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  exportCsv(){
    this.httpService.getMonthlyVatCsv(this.selectedMonth, this.selectedYear, this.selectedOption).subscribe(res => {
      let filename = res.headers.get("filename");
      let csvBodyStr = res.body;
      let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + csvBodyStr);
      let link = document.createElement("a");
      link.href = csvEncodedUri;
      link.download = filename;
      link.click();
    });
  }

}
